import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink'
import { IEcommerceAnswerSchema } from '../../types.ts'
import style from './AldiPriceMatch.module.scss'
import aldiPriceMatchIcon from '../assets/icons/aldiPriceMatch.svg'

interface IAldiPriceMatchProps {
  answer: IEcommerceAnswerSchema
}

// On while the label has text, as in the editor: null or an empty text is off.
const AldiPriceMatch = ({ answer }: IAldiPriceMatchProps) => {
  if (!answer.red_label) return null

  // An inert link like the Clubcard tag: inside a card its click must not also open the product page.
  return (
    <div onClick={event => event.stopPropagation()}>
      <EmptyLink color="#00539f">
        <div className={`${style.aldi} ${style.inert}`}>
          <img src={aldiPriceMatchIcon} alt="" role="presentation" className={style.aldiIcon} />
          <span className={style.aldiText} dangerouslySetInnerHTML={{ __html: answer.red_label }} />
        </div>
      </EmptyLink>
    </div>
  )
}

export default AldiPriceMatch
